import React, { useState } from "react";
import fetchData from "../../api/fetchApi";
function AddUserPage() {
  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [birthday, setBirthday] = useState("");
  const [role, setRole] = useState("admin");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState("");
  const [addSuccess, setAddSuccess] = useState("");

  const handleAddUser = async (e) => {
    e.preventDefault();
    setAddLoading(true);
    setAddError("");
    setAddSuccess("");
    if (!username || !fullName || !phone || !birthday || !role || !password || !passwordConfirm) {
      setAddError("يرجى تعبئة جميع الحقول");
      setAddLoading(false);
      return;
    }
    if (password !== passwordConfirm) {
      setAddError("كلمتا السر غير متطابقتين");
      setAddLoading(false);
      return;
    }
    try {
      await fetchData("admin/user", "POST", {
        username,
        name: fullName,
        phone_number: phone,
        birthday,
        role,
        password,
      
      });
      setAddSuccess("تمت إضافة المسؤول بنجاح");
      setUsername("");
      setFullName("");
      setPhone("");
      setBirthday("");
      setRole("admin");
      setPassword("");
 
    } catch (err) {
      setAddError("فشل في إضافة المسؤول");
    } finally {
      setAddLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-6 bg-gray-50" dir="rtl">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="text-lg font-semibold">اضافة مسؤول جديد</div>
        </div>
        <form onSubmit={handleAddUser} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 space-y-6">
          <div>
            <label className="block text-sm text-gray-600 mb-1">اسم المستخدم</label>
            <input value={username} onChange={e=>setUsername(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">الاسم الكامل</label>
            <input value={fullName} onChange={e=>setFullName(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">رقم الهاتف</label>
            <input value={phone} onChange={e=>setPhone(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">تاريخ الميلاد</label>
            <input type="date" value={birthday} onChange={e=>setBirthday(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">الدور</label>
            <select value={role} onChange={e=>setRole(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3">
              <option value="admin">مسؤول</option>
              <option value="user">مستخدم</option>
            </select>
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">كلمة السر</label>
            <div className="relative">
              <input type={showPassword?"text":"password"} value={password} onChange={e=>setPassword(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
              <button type="button" onClick={()=>setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">{showPassword? '🙈':'👁'}</button>
            </div>
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">تأكيد كلمة السر</label>
            <input type={showPassword?"text":"password"} value={passwordConfirm} onChange={e=>setPasswordConfirm(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          </div>
          {addError && <div className="text-red-600 text-sm">{addError}</div>}
          {addSuccess && <div className="text-green-600 text-sm">{addSuccess}</div>}
          <div className="flex justify-end">
            <button type="submit" className="px-6 py-3 rounded-lg bg-[#8C1C13] text-white" disabled={addLoading}>{addLoading ? 'جاري الإضافة...' : 'اضافة المسؤول'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default AddUserPage;